import { Routes } from '../api-routes'
import { BeneficiaryFiltersDTO, SortOption } from '../dtos/beneficiary'
import { CaseWorkerDTO, CaseWorkerRole } from '../dtos/caseWorker'
import { RequestPayload, ResponseData, SuccessResponseDTO } from '../dtos/generic'
import { getPath, setP } from './helpers'
import { defineRoute } from './new-helpers'

export const CaseWorkersRoutes2 = {
  assignCaseWorkerToBeneficiary: defineRoute<'PATCH', ResponseData<SuccessResponseDTO>>({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/beneficiaries/:beneficiaryId/assign`,
  }),
  unassignCaseWorkerFromBeneficiary: defineRoute<'PATCH', ResponseData<SuccessResponseDTO>>({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/beneficiaries/:beneficiaryId/unassign`,
  }),
  assignCaseWorkerToBeneficiariesFromFilters: defineRoute<
    'PATCH',
    ResponseData<SuccessResponseDTO>,
    RequestPayload<{
      filters: BeneficiaryFiltersDTO
      sortOption: SortOption
    }>
  >({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/beneficiaries/assign-from-filters`,
  }),
  unassignCaseWorkerFromBeneficiariesFromFilters: defineRoute<
    'PATCH',
    ResponseData<SuccessResponseDTO>,
    RequestPayload<{
      filters: BeneficiaryFiltersDTO
      sortOption: SortOption
    }>
  >({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/beneficiaries/unassign-from-filters`,
  }),
}

export namespace CaseWorkersRoutes {
  export namespace get {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, { suffix: Routes.CaseWorkers })
    }
    export type Response = { caseWorkers: CaseWorkerDTO[] }
  }

  export namespace getOne {
    export function call(p = setP(['organizationId', 'caseWorkerId'])) {
      return getPath(p)
    }
    export type Response = { caseWorker: CaseWorkerDTO }
  }

  export namespace getCurrent {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, { suffix: `${Routes.CaseWorkers}/get/current` })
    }
    export type Response = { caseWorker: CaseWorkerDTO }
  }

  export namespace patchOne {
    export function call(p = setP(['organizationId', 'caseWorkerId'])) {
      return getPath(p)
    }
    export type Request = {
      fields: Partial<Pick<CaseWorkerDTO, 'firstName' | 'lastName' | 'role'>>
    }
    export type Response = { caseWorker: CaseWorkerDTO }
  }

  export namespace patchCurrent {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, { suffix: `${Routes.CaseWorkers}/current` })
    }
    export type Request = {
      fields: Partial<Pick<CaseWorkerDTO, 'firstName' | 'lastName' | 'language'>>
    }
    export type Response = { caseWorker: CaseWorkerDTO }
  }

  export namespace disableOrEnableOne {
    export function call(p = setP(['organizationId', 'caseWorkerId'])) {
      return getPath(p, { suffix: 'disable-or-enable' })
    }
    export type Request = { disabled: boolean }
    export type Response = { caseWorker: CaseWorkerDTO }
  }

  export namespace inviteOne {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, { suffix: `${Routes.CaseWorkers}/inviteOne` })
    }
    export type Request = {
      fields: {
        email: string
        firstName: string
        lastName: string
        role: CaseWorkerRole
      }
    }
    export type Response = { caseWorker: CaseWorkerDTO }
  }
}
